export default __webpack_public_path__ + "static/media/mic-stand.118e97c0.png";